<template>
  <Main>
    <ToolsPanel :breadCrumbFirst="'FAQ Item'" :title="'FAQ Item List'">
      <div class="list__buttons">
        <div class="list__search">
          <InputSearch
            :search="handleSearch"
            :id="'search'"
            :label="'search'"
            :placeholder="'search...'"
            :setValue="filterData"
          />
        </div>
        <MainButton @click.native="handleCreate()">Create</MainButton>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div class="list">
        <div v-if="faqItemList.length">
          <CustomTable
            v-if="faqItemList.length"
            :data="faqItemList"
            :deleted-keys="tableOptions.deletedKeys"
            :rename-columns="tableOptions.renameColumn"
            :custom-order="tableOptions.customOrder"
            :is-action-block-visible="tableOptions.isActionBlockVisible"
            :handle-delete="handleDelete"
            :handle-edit="handleEdit"
            :handleFilter="handleFilter"
            :direction="directionSort"
            :order="orderSort"
          >
          </CustomTable>
          <div class="pagination">
            <Pagination
              :maxPage="faqItem.lastPage"
              :page="page"
              :dataList="faqItem"
              :urlList="'FAQ_ITEM_LIST'"
            />
          </div>
        </div>
        <div class="list__no-have" v-else>No FAQ Item found by this parameter.</div>
      </div>
    </ContentContainer>
    <ModalError
      :error-modal="false"
      :handle-close-error-modal="
        () => {
          this.error = {};
        }
      "
    />
    <MainModal v-if="deleteModal" :on-close="handleCloseConfirmModal" :modal-center="true">
      <div class="list__confirm">
        <div class="list__confirm-title">
          Do you want to delete the FAQ Item - {{ deleteRow.name }}?
        </div>
        <div class="list__confirm-buttons">
          <div class="list__confirm-button">
            <MainButton buttonWhite @click.native="handleCloseConfirmModal">CANCEL</MainButton>
          </div>
          <div class="list__confirm-button">
            <MainButton @click.native="handleDeleteRow" :button-cancel="true">DELETE</MainButton>
          </div>
        </div>
      </div>
    </MainModal>
    <MainModal v-if="deleteModalSuccess" :on-close="handleCloseSuccessModal">
      <div class="list__success-delete">FAQ Item {{ deleteRow.name }} successfully deleted.</div>
    </MainModal>
    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import faqApi from "~/api/faq";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import CustomTable from "~/components/molecules/CustomTable.vue";
import Pagination from "~/components/molecules/Pagination.vue";
import MainModal from "~/components/molecules/MainModal.vue";
import ModalError from "~/components/molecules/ModalError.vue";
import InputSearch from "~/components/atoms/inputs/InputSearch.vue";

export default {
  name: "FaqItemList",
  metaInfo: {
    title: "FAQ Item List",
  },
  data() {
    return {
      deleteModal: false,
      deleteRow: null,
      deleteModalSuccess: false,
      directionSort: true,
      orderSort: "id",
      filterData: {
        search: null,
      },
      tableOptions: {
        deletedKeys: ["null"],
        isActionBlockVisible: true,
        renameColumn: [
          {
            from: "id",
            to: "ID",
          },
          {
            from: "question",
            to: "Question",
          },
          {
            from: "answer",
            to: "Answer",
          },
          {
            from: "status",
            to: "Status",
          },
        ],
        customOrder: ["id", "question", "answer", "status", "null"],
      },
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    CustomTable,
    Pagination,
    MainModal,
    ModalError,
    InputSearch,
  },
  mounted() {
    // this.getList();
    this.setQueryParams();
  },
  watch: {
    $route(to, from) {
      this.getList();
    },
  },
  computed: {
    ...mapState("faq", ["error", "loadingProcess", "faqItem", "faqItemList"]),
    page() {
      return +this.$route.params.page;
    },
    getQueryParameters() {
      const query = this.$route.fullPath.split("?")[1];
      if (query) {
        return `?${query}`;
      } else {
        return "";
      }
    },
  },
  methods: {
    getList() {
      let url = `?page=${this.page}`;
      if (this.orderSort.length) {
        url = url + `&sortField=${this.orderSort}&sortDest=${this.directionSort ? "asc" : "desc"}`;
      }
      if (this.filterData.search != null) {
        const data = {};
        data.search = this.filterData.search;
        this.$store.commit("faq/setLoading", true);
        faqApi
          .getFaqItemListFilter(url, data)
          .then((res) => {
            this.$store.commit("faq/setError", {});
            this.$store.commit("faq/setValidationErrors", {});

            this.$store.commit("faq/setFaqItemList", res.data.items.data);
            this.$store.commit("faq/setFaqItem", res.data.items);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.$store.commit("faq/setLoading", false);
          });
      } else {
        this.$store.dispatch("faq/getFaqItemList", url);
      }
    },
    handleSearch() {
      this.handleSetQueryParams();
    },
    handleGetQueryParam(param) {
      if (this.$route.query[param] != undefined) {
        return this.$route.query[param];
      } else {
        return null;
      }
    },
    setQueryParams() {
      if (this.handleGetQueryParam("search")) {
        this.filterData.search = this.handleGetQueryParam("search");
      }

      this.getList();
    },
    handleSetQueryParams() {
      const filter = {};
      if (this.filterData.search != null) {
        filter.search = this.filterData.search;
      }
      if (this.page != 1) {
        this.$router.push({
          path: ROUTE.FAQ_ITEM_LIST.replace(":page", 1),
        });
      }
      this.$router.push({
        name: "FaqItemsList",
        query: filter,
      });
    },
    handleFilter(column) {
      this.orderSort = column;
      if (this.directionSort === null) {
        this.directionSort = true;
      } else {
        this.directionSort = !this.directionSort;
      }
      this.getList();
    },
    handleDelete(row) {
      this.deleteModal = true;
      this.deleteRow = row;
    },
    handleEdit(row) {
      this.$router.push({
        path: ROUTE.FAQ_ITEM_EDIT.replace(":id", `${row.id}`),
      });
    },
    handleCreate() {
      this.$router.push({
        path: ROUTE.FAQ_ITEM_CREATE,
      });
    },
    handleCloseConfirmModal() {
      this.deleteModal = false;
    },
    handleDeleteRow() {
      const url = `/${this.deleteRow.id}`;
      this.$store.commit("faq/setLoading", true);
      faqApi
        .deleteFaqItem(url)
        .then((res) => {
          this.$store.commit("faq/setLoading", false);
          if (res.success) {
            this.getList();
            this.handleCloseConfirmModal();
            this.deleteModalSuccess = true;
          }
        })
        .catch((error) => {
          this.$store.commit("faq/setLoading", false);
          console.log(error);
        });
    },
    handleCloseSuccessModal() {
      this.deleteModalSuccess = false;
    },
    closeModal() {
      this.error = null;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.custom-table__header,
/deep/.custom-table__row {
  grid-template-columns: 0.4fr 2fr 2fr 1fr 1fr !important;
}

.list {
  &__buttons {
    display: flex;
  }
  &__search {
    min-width: 250px;
    margin-right: 20px;
  }
}
</style>
